import React, { useEffect, useState } from 'react';
import { Snackbar, Button, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import sessionRefreshService from '../services/sessionRefreshService';
import {
  SESSION_EXPIRING_SHOW_EVENT,
  SESSION_EXPIRING_DISMISS_EVENT,
} from '../services/sessionRefreshService';

export default function SessionExpirySnackbar() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleShow = () => setOpen(true);
    const handleDismiss = () => setOpen(false);

    window.addEventListener(SESSION_EXPIRING_SHOW_EVENT, handleShow);
    window.addEventListener(SESSION_EXPIRING_DISMISS_EVENT, handleDismiss);

    return () => {
      window.removeEventListener(SESSION_EXPIRING_SHOW_EVENT, handleShow);
      window.removeEventListener(SESSION_EXPIRING_DISMISS_EVENT, handleDismiss);
    };
  }, []);

  const handleExtendSession = async () => {
    const success = await sessionRefreshService.extendSession();
    if (success) {
      setOpen(false);
      return;
    }

    // Refresh cannot be completed (for example missing/expired refresh token).
    // Close the stale warning and take the user back to login.
    setOpen(false);
    if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
  };

  const handleClose = (
    _event?: Event | React.SyntheticEvent,
    reason?: 'timeout' | 'clickaway' | 'escapeKeyDown',
  ) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      data-testid="session-warning"
      onClose={handleClose}
      message={
        <Typography component="span">
          Session expiring soon - your session will expire in 2 minutes. Select Extend session to stay signed in.
        </Typography>
      }
      action={
        <>
          <Button
            color="inherit"
            size="small"
            onClick={handleExtendSession}
            data-testid="extend-session-button"
          >
            Extend session
          </Button>
          <IconButton
            aria-label="Dismiss session warning"
            color="inherit"
            size="small"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      }
    />
  );
}
